import React from 'react';

type MouseKeyboardEventHandler = React.MouseEventHandler<HTMLElement> & React.KeyboardEventHandler<HTMLElement>;

type Props = React.HTMLAttributes<HTMLDivElement> & {
    onClick: MouseKeyboardEventHandler;
    children: React.ReactNode;
};

export function createInteractiveProps(onClick: MouseKeyboardEventHandler) {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            onClick(event);
        }
    };

    return { onClick, onKeyDown: handleKeyDown, role: 'button', tabIndex: 0 };
}

function DivButton({ onClick, children, ...rest }: Props, ref: React.RefObject<HTMLDivElement>) {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <div {...createInteractiveProps(onClick)} {...rest} ref={ref}>
            {children}
        </div>
    );
}

export default React.forwardRef(DivButton);
